<template>
  <div class="card" id="titulo">
    <div class="card-header">
      <div class="row headerCard">
        <div class="col-md-2">
          <i class="fas fa-cube mr-2"></i>
          <p class="d-inline fw-bold">NCM {{ monitorada.ncm }}</p>
        </div>
        <div class="col-md-7">
          <p class="d-inline fs-12">{{ monitorada.descricao }}</p>
        </div>
        <div class="col-md-2" @click="maisInformacoes()">
          <img
            src="https://www.lefisc.com.br/monitoramentoncm/img/info2.png"
            class="img-fluid"
            alt
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import serviceMonitoramento from "../services/ServiceMonitoramentoAlteracoes";
import serviceCookie from "../services/ServiceCookie";
export default {
  props: {
    monitorada: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loadingMonitoramento: false,
    };
  },

  async created() {
    
  },

  methods: {
    maisInformacoes() {
      this.$router.push({
        name: "Histórico",
        params: { ncm: this.monitorada.ncm }
      });
    },
  }
};
</script>

<style scoped>
.fs-20 {
  font-size: 15px;
  color: gray;
}

.loading {
  height: 16px;
  width: 16px;
  font-size: 10px;
}

.exibir-enter,
.exibir-leave-to {
  min-height: 0;
  max-height: 0;
  opacity: 0;
}

.exibir-enter-to,
.exibir-leave {
  min-height: 1;
  max-height: 700px;
}

.exibir-leave-active,
.exibir-enter-active {
  transition: all 0.4s;
}

.headerCard p {
  color: black;
}
.fs-12 {
  font-size: 12px;
}
.card-header {
  cursor: pointer;
}

.fw-bold {
  font-weight: bold;
}

.iconeContent {
  height: 100px;
  width: 100px;
}

.titulo {
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  margin-top: 20px;
}

.alerta {
  font-size: 12px;
  margin-top: 10px;
}

.iconeLoading {
  font-size: 20px;
  width: 50px;
  height: 50px;
}

.fs-15 {
  font-size: 15px;
}

@media (max-width: 768px) {
  .img-fluid {
    margin-bottom: 20px;
  }
}
</style>